export default {
  "content": "<path fill=\"#444\" d=\"M3.768 3.92C4.875 3.056 6.295 2.4 8 2.4c2.02 0 3.637.92 4.815 2.015 1.17 1.085 1.953 2.362 2.322 3.277a.795.795 0 010 .615c-.335.808-1.007 1.945-1.997 2.96l2.63 2.06a.6.6 0 01-.74.945L.23 2.672a.6.6 0 11.74-.944l2.797 2.191zm1.81 1.417l2.257 1.77c.105-.212.165-.452.165-.73 0-.265-.098-.535-.21-.767.07-.008.14-.033.21-.033a2.4 2.4 0 012.4 2.4c0 .365-.072.69-.223.985l.988.755a3.6 3.6 0 00.435-1.74c0-1.965-1.613-3.6-3.6-3.6-.933 0-1.785.378-2.423.96zM8 13.6c-2.02 0-3.638-.92-4.815-2.015C2.015 10.477 1.233 9.2.861 8.307a.8.8 0 010-.615 9.506 9.506 0 011.216-2.055l2.358 1.858a3.606 3.606 0 004.89 3.853l1.83 1.44A6.57 6.57 0 018 13.6z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 16 16"
  }
};